var _g, _path, _g2, _path2, _path3, _g3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_428_36016)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3551 7.3076H11.072V6.46239C11.072 6.23823 10.9829 6.02325 10.8244 5.86474C10.6659 5.70624 10.4509 5.61719 10.2268 5.61719H6.84594C6.62177 5.61719 6.40679 5.70624 6.24828 5.86474C6.08978 6.02325 6.00073 6.23823 6.00073 6.46239V7.3076H5.71336C5.67749 7.3076 5.6431 7.32185 5.61773 7.34721C5.59237 7.37257 5.57812 7.40697 5.57812 7.44284V8.44018C5.57812 8.51498 5.63856 8.57541 5.71336 8.57541H6.00073V11.111C6.00073 11.3435 6.00073 11.5336 6.42333 11.5336V12.1675C6.42333 12.2236 6.4456 12.2773 6.48522 12.317C6.52485 12.3566 6.57859 12.3788 6.63463 12.3788H7.47984C7.53588 12.3788 7.58963 12.3566 7.62926 12.317C7.66888 12.2773 7.69114 12.2236 7.69114 12.1675V11.5336H9.38156V12.1675C9.38156 12.2236 9.40382 12.2773 9.44345 12.317C9.48308 12.3566 9.53682 12.3788 9.59286 12.3788H10.4381C10.4941 12.3788 10.5479 12.3566 10.5875 12.317C10.6271 12.2773 10.6494 12.2236 10.6494 12.1675V11.5336C11.072 11.5336 11.072 11.3435 11.072 11.111V8.57541H11.3551C11.3921 8.57541 11.4276 8.56072 11.4537 8.53457C11.4799 8.50841 11.4946 8.47294 11.4946 8.43595C11.4946 8.39897 11.4799 8.3635 11.4537 8.33734C11.4276 8.31119 11.3921 8.29649 11.3551 8.29649C11.3181 8.29649 11.2827 8.31119 11.2565 8.33734C11.2304 8.3635 11.2157 8.39897 11.2157 8.43595C11.2157 8.47294 11.2304 8.50841 11.2565 8.53457C11.2827 8.56072 11.3181 8.57541 11.3551 8.57541C11.3921 8.57541 11.4276 8.56072 11.4537 8.53457C11.4799 8.50841 11.4946 8.47294 11.4946 8.43595V7.44706C11.4946 7.41007 11.4799 7.3746 11.4537 7.34845C11.4276 7.3223 11.3921 7.3076 11.3551 7.3076ZM7.69114 6.03979H9.38156V6.46239H7.69114V6.03979ZM6.84594 10.6884C6.73386 10.6884 6.62636 10.6439 6.54711 10.5647C6.46786 10.4854 6.42333 10.3779 6.42333 10.2658C6.42333 10.1537 6.46786 10.0463 6.54711 9.967C6.62636 9.88775 6.73386 9.84322 6.84594 9.84322C6.95802 9.84322 7.06551 9.88775 7.14476 9.967C7.22402 10.0463 7.26854 10.1537 7.26854 10.2658C7.26854 10.3779 7.22402 10.4854 7.14476 10.5647C7.06551 10.6439 6.95802 10.6884 6.84594 10.6884ZM6.42333 8.99802V6.885H10.6494V8.99802H6.42333ZM10.2268 10.6884C10.1147 10.6884 10.0072 10.6439 9.92794 10.5647C9.84869 10.4854 9.80416 10.3779 9.80416 10.2658C9.80416 10.1537 9.84869 10.0463 9.92794 9.967C10.0072 9.88775 10.1147 9.84322 10.2268 9.84322C10.3389 9.84322 10.4463 9.88775 10.5256 9.967C10.6048 10.0463 10.6494 10.1537 10.6494 10.2658C10.6494 10.3779 10.6048 10.4854 10.5256 10.5647C10.4463 10.6439 10.3389 10.6884 10.2268 10.6884Z",
    fill: "#02C038"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_428_36016",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 11
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.52267 8.3552L1.42023 8.41317L0.0322137 5.42077L11.7188 0L14.6198 6.25438L5.61567 10.4309L4.67782 8.40905L3.52267 8.3552Z",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_428_36016)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.15501 11.5108C2.49172 10.0808 2.42365 8.4459 2.96578 6.96574C3.5079 5.48558 4.61582 4.28141 6.04579 3.61812C7.47576 2.95483 9.11065 2.88676 10.5908 3.42889C12.071 3.97101 13.2751 5.07892 13.9384 6.50889",
    stroke: "#02C038",
    strokeWidth: 0.95096
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.1477 8.39991L2.67352 10.9854L4.14974 8.37128L1.1477 8.39991Z",
    fill: "#02C038"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_428_36016",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 7,
    width: 16,
    height: 11
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5633 9.6448L15.6657 9.58683L17.0537 12.5792L5.36719 18L2.4661 11.7456L11.4703 7.56906L12.4081 9.59095L13.5633 9.6448Z",
    fill: "#D9D9D9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_428_36016)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9309 6.48924C14.5942 7.91921 14.6623 9.5541 14.1202 11.0343C13.578 12.5144 12.4701 13.7186 11.0401 14.3819C9.61018 15.0452 7.97529 15.1132 6.49513 14.5711C5.01497 14.029 3.81079 12.9211 3.1475 11.4911",
    stroke: "#02C038",
    strokeWidth: 0.95096
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9304 9.60009L14.4046 7.01457L12.9284 9.62872L15.9304 9.60009Z",
    fill: "#02C038"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_428_36016"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.76166,
    height: 6.76166,
    fill: "white",
    transform: "translate(5.15625 5.61719)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/customer.33dddf0de5410a127a5a6f61608f22b9.svg";
export { ForwardRef as ReactComponent };